// extracted by mini-css-extract-plugin
export default {"word-wrap-container":"statistic_word-wrap-container__XzPCa"};